import { render, staticRenderFns } from "./FullscreenImage.vue?vue&type=template&id=1bbfb059&scoped=true&"
import script from "./FullscreenImage.vue?vue&type=script&lang=js&"
export * from "./FullscreenImage.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenImage.vue?vue&type=style&index=0&id=1bbfb059&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbfb059",
  null
  
)

export default component.exports